import { UserShort } from '@/contracts/system-modules/auth/dto/user/UserShort'
import { EnumWorkspace, toWorkspace } from '@/contracts/system-modules/auth/enum/EnumWorkspace'

/** Результат входа по PIN: pending — ждать дальше; confirmed — токен выдан */
export class PinResult {
  status: 'pending' | 'confirmed'
  token: string | null
  expiresAt: string | null
  deviceUuid: string | null
  user: UserShort | null
  /** Только при confirmed: рабочее место устройства после запроса */
  workspace: EnumWorkspace

  constructor({ status, token, expiresAt, deviceUuid, user, workspace }: {
    status: 'pending' | 'confirmed', token?: string, expiresAt?: string, deviceUuid?: string, user?: { uuid: string, name: string }, workspace?: string
  }) {
    this.status = status
    this.token = token ?? null
    this.expiresAt = expiresAt ?? null
    this.deviceUuid = deviceUuid ?? null
    this.user = user ? new UserShort(user) : null
    this.workspace = toWorkspace(workspace)
  }
}

/** Ответ сервера приходит простым объектом, поэтому проверка — функция, а не метод */
export function isPinConfirmed(result: PinResult): result is PinResult & { token: string, deviceUuid: string, user: UserShort } {
  return result.status === 'confirmed' && typeof result.token === 'string' && typeof result.deviceUuid === 'string' && result.user !== null && result.user !== undefined
}
